import { api } from '../config/api';

export const productosService = {
  // Obtener todos los productos con paginación y filtros
  getProductos: async (params = {}) => {
    try {
      const data = await api.get('/api/productos/', params);
      return data;
    } catch (error) {
      throw error;
    }
  },

  // Obtener un producto por ID
  getProducto: async (id) => {
    try {
      const data = await api.get(`/api/productos/${id}/`);
      return data;
    } catch (error) {
      throw error;
    }
  },

  // Crear un nuevo producto
  createProducto: async (productoData) => {
    try {
      const data = await api.post('/api/productos/', productoData);
      return data;
    } catch (error) {
      throw error;
    }
  },

  // Actualizar un producto
  updateProducto: async (id, productoData) => {
    try {
      const data = await api.put(`/api/productos/${id}/`, productoData);
      return data;
    } catch (error) {
      throw error;
    }
  },

  // Eliminar un producto
  deleteProducto: async (id) => {
    try {
      await api.delete(`/api/productos/${id}/`);
      return { success: true };
    } catch (error) {
      throw error;
    }
  },

  // Buscar productos por nombre o código
  searchProductos: async (query) => {
    try {
      const data = await api.get('/api/productos/', { search: query });
      return data;
    } catch (error) {
      throw error;
    }
  },

  // Obtener productos con stock bajo
  getProductosStockBajo: async () => {
    try {
      const data = await api.get('/api/productos/stock-bajo/');
      return data;
    } catch (error) {
      throw error;
    }
  },

  // Obtener categorías de productos
  getCategorias: async () => {
    try {
      const data = await api.get('/api/productos/categorias/');
      return data;
    } catch (error) {
      throw error;
    }
  }
};

export default productosService;

// Made with Bob
